import { render, staticRenderFns } from "./ArticleTypeSelectNav.vue?vue&type=template&id=3af64123&scoped=true&"
import script from "./ArticleTypeSelectNav.vue?vue&type=script&lang=js&"
export * from "./ArticleTypeSelectNav.vue?vue&type=script&lang=js&"
import style0 from "./ArticleTypeSelectNav.vue?vue&type=style&index=0&id=3af64123&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af64123",
  null
  
)

export default component.exports